import React from 'react';
import t from 'babel-plugin-yate/macro';

import {Text} from '../../components/uiElem';
import {formatRON, formatPercent} from '../../lib/misc';

function OfferGroupItem(props) {
  const {
    item: {
      dae,
      financial_product_grace_period,
      installments,
      interest,
      loan_amount,
      pmt,
      is_revolving_eligible,
      revolving_amount,
      is_counter,
    },
    isCreditCard,
  } = props;

  return (
    <React.Fragment>
      {(is_counter || !!financial_product_grace_period) && (
        <Text ui="uranus">
          {is_counter && t`The amount was accepted as counter-offer:`}
          {!!financial_product_grace_period &&
            t`Grace period ${financial_product_grace_period} months`}
        </Text>
      )}

      <div className="my-3">
        {!isCreditCard && (
          <>
            <div className="flex flex-wrap py-2">
              <Text ui="neptune">
                <div className="pr-2">{t`Installment`}:</div>
              </Text>
              <Text ui="mars">{formatRON(pmt)}</Text>
            </div>
            <div className="flex flex-wrap py-2">
              <Text ui="neptune">
                <div className="pr-2">{t`Duration`}:</div>
              </Text>
              <Text ui="mars">{t`${installments} months`}</Text>
            </div>
          </>
        )}

        <div className="flex flex-wrap py-2">
          <Text ui="neptune">
            <div className="pr-2">{t`DAE`}:</div>
          </Text>
          <Text ui="mars">{formatPercent(dae)}</Text>
        </div>

        <div className="flex flex-wrap py-2">
          <Text ui="neptune">
            <div className="pr-2">{t`Interest`}:</div>
          </Text>
          <Text ui="mars">{formatPercent(interest)}</Text>
        </div>

        {!isCreditCard && is_revolving_eligible && !isNaN(revolving_amount) && (
          <div className="flex flex-wrap py-2">
            <Text ui="neptune">
              <div className="pr-2">{t`Limita credit`}:</div>
            </Text>
            <Text ui="mars">{formatRON(revolving_amount)}</Text>
          </div>
        )}

        <div className="flex flex-wrap py-2">
          <Text ui="neptune">
            <div className="pr-2">
              {!isCreditCard ? t`Credit value` : t`Limita card acordata`}:
            </div>
          </Text>
          <Text ui="mars">{formatRON(loan_amount)}</Text>
        </div>
      </div>
    </React.Fragment>
  );
}

export default OfferGroupItem;
